export default __webpack_public_path__ + "static/media/image0.720c27bc.jpg";